/* global swal, _, angular*/
import './style.less';
import { keyBy, clone, get, findIndex } from 'lodash';

export default function($log, $stateParams, Swal, ApiClass, EventClass, CategoryClass, $state, $q) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;

  vm.routeParams = $stateParams;

  vm.pagination = {
    pageSize: 10,
    pageSizes: [10, 25, 50, 100]
  };

  vm.selectAll = select => {
    vm.registrants.forEach(user => {
      user.selected = select;
    });
    vm.updateSelected();
  };

  vm.pollNumbers = () => {
    const length = vm.event.totalPolls || 0;
    return Array.from({ length }, (v, k) => k + 1).reverse();
  };

  vm.attendeeAnsweredPolls = attendee => {
    const reducer = (accumulator, session) => get(session, 'answeredPolls', 0) + accumulator;
    if (!attendee.sessions || !attendee.sessions.length === 1) return 0;

    return attendee.sessions.reduce(reducer, 0);
  };

  vm.registrantSessions = attendee => {
    if (!attendee.sessions) return 0;
    return attendee.sessions.filter(session => !!session).length;
  };

  vm.singleDuration = attendee => {
    const reducer = (accumulator, session) => get(session, 'duration', 0) + accumulator;
    if (!attendee.sessions && !attendee.sessions[0]) return 0;

    return attendee.sessions.reduce(reducer, 0);
  };

  vm.updateSelected = () => (vm.selected = vm.registrants.filter(user => user.selected).length);

  vm.display = (registrant, prop) => {
    switch (prop) {
      case 'hours':
        registrant.displayExternals = false;

        ApiClass.usersIdGet(
          { id: registrant.profile_uid },
          {},
          {
            queryParams: {
              'include:withchildren': true
            }
          },
          true
        )
          .then(({ data: { item: profile } }) => {
            registrant.profile = profile;
            registrant.displayHours = !registrant.displayHours;
          })
          .catch(error => {
            registrant.displayHours = !registrant.displayHours;
          });

        break;
      case 'blended':
      case 'polls':
      case 'duration':
        registrant.displayHours = false;
        registrant.displayExternals = !registrant.displayExternals;
        break;
    }
  };

  vm.filter = () => {
    let registrants;

    switch (vm.evalFilter) {
      case 'complete':
        registrants = clone(vm.locationRegistrants).filter(({ profile_uid }) => vm.reviewsObj[profile_uid]);
        break;
      case 'incomplete':
        registrants = clone(vm.locationRegistrants).filter(({ profile_uid }) => !vm.reviewsObj[profile_uid]);
        break;
      default:
        registrants = clone(vm.locationRegistrants);
        break;
    }

    if (vm.pollFilter !== undefined && vm.pollFilter !== '')
      registrants = registrants.filter(({ attendeeAnsweredPolls }) => (attendeeAnsweredPolls || 0) === vm.pollFilter);

    vm.registrants = registrants;
  };

  vm.submit = () => {
    const selectedRegistrants = vm.registrants.filter(({ selected }) => selected);
    if (!selectedRegistrants.length) return Swal.alert('Hold Up!', 'No registrants have been selected', 'info');
    vm.submitBtn = true;

    vm.action({ certs: selectedRegistrants, suppress: vm.suppress })
      .then(() => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
      })
      .catch(error => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
        throw error;
      });
  };

  vm.sendEvals = () => {
    vm.submitBtn = true;
    const profile_uids = vm.registrants.filter(({ selected }) => selected).map(({ profile_uid }) => profile_uid);

    checkDate()
      .then(() =>
        ApiClass.eventsIdTypePatch(
          { id: vm.event.event_id, type: 'attendees' },
          { profile_uids, sendEval: true },
          { queryParams: { manage: true } }
        )
      )
      .then(() => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
        Swal.toast('Evaluations sent!');
      })
      .catch(error => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
        throw error;
      });
  };

  function checkDate() {
    if (new Date(vm.event.delivery_end_date).getTime() > new Date().getTime()) {
      return Swal.confirm(
        'Send Evaluations',
        'This event has not ended. Do you still want to send evaluations?',
        'info'
      );
    }
    return Promise.resolve();
  }

  vm.sendPostwork = () => {
    vm.submitBtn = true;
    const profile_uids = vm.registrants.filter(({ selected }) => selected).map(({ profile_uid }) => profile_uid);
    ApiClass.eventsIdTypePatch(
      { id: vm.event.event_id, type: 'attendees' },
      { profile_uids, sendPostwork: true },
      { queryParams: { manage: true } }
    )
      .then(() => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
        Swal.toast('Postwork sent!');
      })
      .catch(error => {
        vm.submitBtn = false;
        vm.selectAll(false, true);
        throw error;
      });
  };

  vm.syncWithEvent = () => {
    const selectedRegistrants = vm.registrants.filter(({ selected }) => selected);
    if (!selectedRegistrants.length) return Swal.alert('Hold Up!', 'No registrants have been selected', 'info');

    vm.registrants.forEach(registrant => {
      if (registrant.selected) {
        registrant.displayHours = false;
        registrant.hours = angular.copy(vm.event.hours || []);
        registrant.hours_basic = angular.copy(vm.event.hours_basic || []);
      }
    });

    Swal.html(
      'Registrants Updated!',
      `<p>The credits for the selected registrants have been updated with the current credit values.</p>
      <p>Attendees who require adjustment will need to be updated prior to submitting and re-issuing certificates.</p>`,
      'info'
    );
  };

  vm.syncWithCnf = () => {
    Swal.confirmHtml(
      'Hold Up!',
      `<p>To ensure your synced credits match your latest updates in Conferences i/o, please click the Reload button, wait for the page to refresh, then click the Sync button to proceed.</p>
      <p>If you haven’t made any recent changes to the credit data in Conferences i/o, you may simply click the Sync button below.</p>`,
      'select',
      'Reload',
      'Sync'
    )
      .then(() => {
        refetchCnfExternals();
      })
      .catch(error => {
        if (error.dismiss === 'cancel') {
          const selectedRegistrants = vm.registrants.filter(({ selected }) => selected);
          if (!selectedRegistrants.length) return Swal.alert('Hold Up!', 'No registrants have been selected', 'info');

          // checkCnfHours
          let newHoursSubject = false;

          const error = vm.registrants.some(registrant => {
            if (registrant.selected) {
              return checkCnf(registrant.sessions, newHoursSubject);
            }
          });

          if (error) return;

          // Buidls cnf hours
          vm.registrants.forEach(registrant => {
            if (registrant.selected) {
              const hours = calcCnfHours(registrant.sessions);
              if (hours.length) {
                registrant.displayHours = false;
                registrant.hours = angular.copy(hours);
                registrant.hours_basic = angular.copy(hours);
              } else {
                registrant.hours.forEach(hour => (hour.credits = 0));
                if (registrant.hours_basic && registrant.hours_basic.length)
                  registrant.hours_basic.forEach(hour => (hour.credits = 0));
              }
            }
          });

          return Swal.html(
            'Registrants Updated!',
            `<p>The credits for the selected registrants have been updated with the adjusted credit values from Conferences  i/o.</p>
          <p>Note that any selected attendees that were registered for this Event but did not check into Conferences i/o will have their credits adjusted to zero.</p>`,
            'success'
          );
        }
      });
  };

  function refetchCnfExternals() {
    vm.loaded = false;
    $q.all(
      vm.event.externals.filter(({ type }) => type === 'cnfExternal').map(external => {
        return ApiClass.eventsIdTypeTypeIdPatch(
          { id: vm.event.event_id, type_id: external.uuid, type: 'eventExternal' },
          { fetched: false, type: 'cnfExternal' },
          {
            queryParams: { manage: true }
          }
        );
      })
    )
      .then(() => $state.reload())
      .then(() => (vm.loaded = true));
  }

  vm.externalWebinars = EventClass.externalWebinars;
  vm.externalFetchedWebinars = EventClass.externalFetchedWebinars;
  vm.externalHasCustomHours = EventClass.hasCustomHours;

  function calcCnfHours(sessions) {
    const hours = [];
    sessions.forEach(session => {
      if (session && session.fieldOfStudy) {
        (session.fieldOfStudy || []).forEach(({ name, credits }) => {
          const { category_id, name: subject_area } = vm.categoryDict[name];
          const index = findIndex(hours, { category_id });
          if (index === -1) {
            hours.push({ category_id, subject_area, credits });
          } else {
            hours[index].credits += credits;
          }
        });
      }
    });
    hours.forEach(item => {
      if (item.credits) {
        item.credits = parseFloat(item.credits.toFixed(1));
      }
    });
    return hours;
  }

  function checkCnf(sessions, nonEventSubject) {
    const hourSubjects = vm.event.hours.map(({ subject_area }) => subject_area);

    return sessions.some(session => {
      if (session && session.fieldOfStudy) {
        return session.fieldOfStudy.some(({ name }) => {
          if (!vm.categoryDict[name]) {
            Swal.html(
              'Incompatible Subject Area',
              `<p>A Conferences.IO subject area for the selected session(s) don't have an exact match in Prolaera.  Please check for typos and verify that the Subject Areas in Conferences.IO exactly match the subject area format in Prolaera.</p>`,
              'info'
            );
            return true;
          }

          if (!hourSubjects.includes(name)) {
            nonEventSubject = true;
          }
          return false;
        });
      }
    });
  }

  function buildCodeWordsCount(attendee) {
    const reduceField = (accumulator, field) => {
      return {
        codewordsValid: accumulator.codewordsValid + get(field, 'codewords.valid', 0),
        codewordsPossible: accumulator.codewordsPossible + get(field, 'codewords.possible', 0)
      };
    };

    const reduceSessions = (accumulator, session) => {
      if (!session || !session.fieldOfStudy) return accumulator;
      return session.fieldOfStudy.reduce(reduceField, accumulator);
    };

    return attendee.sessions.reduce(reduceSessions, { codewordsValid: 0, codewordsPossible: 0 });
  }

  function activate() {
    $log.debug('Event Manager External Issue Component Activated');
    vm.selected = 0;

    try {
      if (!vm.event) throw new Error('No Event');
      if (!vm.action) throw new Error('No Action');
      vm.reviewsObj = keyBy(vm.event.reviews, 'profile_uid');

      vm.hasCodeWords = EventClass.hasCodeWords(vm.event, vm.registrants);

      vm.locationRegistrants = vm.registrants.map(attendee => {
        attendee.attendeeAnsweredPolls = vm.attendeeAnsweredPolls(attendee);
        if (vm.hasCodeWords) {
          const { codewordsValid, codewordsPossible } = buildCodeWordsCount(attendee);
          attendee.codewordsPossible = codewordsPossible;
          attendee.codewordsValid = codewordsValid;
        }
        return { ...attendee };
      });

      vm.getter = vm.externalWebinars(vm.event).reduce(
        (getterObj, external, index) => {
          getterObj[`${index}`] = value => {
            return value.sessions[index] ? value.sessions[index].duration : 0;
          };
          return getterObj;
        },
        {
          sessionLength: value => vm.registrantSessions(value),
          singleDuration: value => vm.singleDuration(value)
        }
      );

      CategoryClass.loadCategories().then(({ arr }) => {
        vm.categoryDict = keyBy(arr, 'name');
        vm.loaded = true;
      });
    } catch (error) {
      vm.loaded = true;
      vm.error = {
        status: true,
        refresh: activate
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/issueCertificatesExternals/controller.js